import React from 'react';
import { useSelector } from 'react-redux';
import { selectPageLoadingState } from 'store/LoadingReduxState';
import { ForgeBusyIndicator } from '@tylertech/forge-extended-react';

export function FullPageLoading() {
  const { loading, message } = useSelector(selectPageLoadingState);

  return <ForgeBusyIndicator open={loading} message={message} />;
}
